const endpointBase = import.meta.env.DEV ? 'https://sh.personenportal.ch' : ''

export function getRdbmsApiUrl(path: string): string {
  const normalizedPath = path.replace(/^\/+/, '')
  return `${endpointBase}/wp-json/person-filter/rdbms/${normalizedPath}`
}

export async function fetchRdbmsJson<T>(
  path: string,
  {
    method = 'GET',
    body,
    signal,
  }: {
    method?: 'GET' | 'POST'
    body?: unknown
    signal?: AbortSignal
  } = {},
): Promise<T> {
  const response = await fetch(getRdbmsApiUrl(path), {
    method,
    signal,
    headers: {
      Accept: 'application/json',
      ...(method === 'POST' ? { 'Content-Type': 'application/json' } : {}),
    },
    body: method === 'POST' ? JSON.stringify(body ?? {}) : undefined,
  })

  if (!response.ok) {
    throw new Error(`RDBMS request failed (${response.status})`)
  }

  return response.json() as Promise<T>
}

